import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './apiClient'

/**
 * Shared React Query client.
 *
 * 4xx responses are deterministic (validation, permissions, missing rows) and
 * are never retried; 5xx and transport failures get a couple of attempts.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status > 0 && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
